import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Navbar from './components/Navbar';
import Inicio  from './pages/inicio';
import SubNavbar from './components/SubNavbar';
import KioskoInicio from './pages/KioskoInicio';
import OperacionInicio from './pages/OperacionInicio';
import HandheldInicio from './pages/HandheldInicio';
import HHBitacoraPage from './pages/HHBitacoraPage'
import HHDailyOperatorsInfo from './pages/HHDailyOperatorsInfo'
import HHLlegadas from './pages/HHllegadas'
import HHServicioManual from './pages/HHServicioManualPage'
import HHServicios from './pages/HHServicios'
import PendientesPage from './pages/PendientesPage';
import COLlegadasPage from './pages/COLlegadasPage';
import FloatingBubbleModal from './components/FloatingBubbleModal';
import FloatingVuelosModal from './components/FloatingVuelosModal';
import FloatingGestionUsuariosModal from './components/FloatingGestionUsuariosModal';
import { useSelector } from 'react-redux';


// Función para decodificar el JWT
const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

// Función para validar el token
const isTokenValid = (token) => {
  if (!token) return false;
  const decoded = parseJwt(token);
  if (!decoded || !decoded.exp) return false;
  return decoded.exp * 1000 >= Date.now();
};


const App = () => {
  const token = useSelector((state) => state.auth.token);
  const isAuthenticated = isTokenValid(token);


  const AuthenticatedLayout = ({ children }) => {
    const location = useLocation();
    const isLogin = location.pathname === '/';
  
    const isHandheld = location.pathname.startsWith('/handheld');
    const isOperacion = location.pathname.startsWith('/operacion');
    const isKiosko = location.pathname.startsWith('/kiosko');
  
    return (
      <>
        {!isLogin && <Navbar />}
        {!isLogin && <SubNavbar />}
  
        {children}
  
        {/* Menús flotantes por sección */}
        {isHandheld && (
          <>
            <FloatingBubbleModal />
            <FloatingVuelosModal />
            <FloatingGestionUsuariosModal />
          </>
        )}
  
        {isOperacion && (
          <>
            {/* Aquí irían los menús flotantes para operacion si los tienes */}
          </>
        )}
  
        {isKiosko && (
          <>
            {/* Aquí irían los menús flotantes para kiosko si los tienes */}
          </>
        )}
      </>
    );
  };

  return (
    <Router>
      <Routes>
        {/* Ruta para el Login */}
        <Route path="/" element={<Login />} />


        {/* Ruta para Servicios */}
        <Route
          path="/inicio"
          element={
            isAuthenticated ?
             (
              <AuthenticatedLayout>
                <Inicio />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        /> 
        <Route
  path="/kiosko"
  element={isAuthenticated ? <AuthenticatedLayout><KioskoInicio /></AuthenticatedLayout> : <Navigate to="/" />}
/>
<Route
  path="/coordinacion"
  element={isAuthenticated ? <AuthenticatedLayout><OperacionInicio /></AuthenticatedLayout> : <Navigate to="/" />}
/>
<Route
  path="/handheld"
  element={isAuthenticated ? <AuthenticatedLayout><HandheldInicio /></AuthenticatedLayout> : <Navigate to="/" />}
/>

        {/* Ruta para Llegadas */}
        <Route
          path="/handheld/llegadas"
          element={
            isAuthenticated ?
             (
              <AuthenticatedLayout>
                <HHLlegadas />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        /> 
        <Route
  path="/handheld/bitacora"
  element={
    isAuthenticated ? (
      <AuthenticatedLayout>
        <HHBitacoraPage />
      </AuthenticatedLayout>
    ) : (
      <Navigate to="/" />
    )
  }
/>

<Route
  path="/handheld/salidas"
  element={
    isAuthenticated ? (
      <AuthenticatedLayout>
        <HHServicios />
      </AuthenticatedLayout>
    ) : (
      <Navigate to="/" />
    )
  }
/>

<Route
  path="/handheld/gestion"
  element={
    isAuthenticated ? (
      <AuthenticatedLayout>
        <HHDailyOperatorsInfo />
      </AuthenticatedLayout>
    ) : (
      <Navigate to="/" />
    )
  }
/>

<Route
  path="/handheld/manual"
  element={
    isAuthenticated ? (
      <AuthenticatedLayout>
        <HHServicioManual />
      </AuthenticatedLayout>
    ) : (
      <Navigate to="/" />
    )
  }
/>

<Route
  path="/handheld/pendientes"
  element={
    isAuthenticated ? (
      <AuthenticatedLayout>
        <PendientesPage />
      </AuthenticatedLayout>
    ) : (
      <Navigate to="/" />
    )
  }
/>

<Route
  path="/coordinacion/llegadaspage"
  element={
    isAuthenticated ? (
      <AuthenticatedLayout>
        <COLlegadasPage />
      </AuthenticatedLayout>
    ) : (
      <Navigate to="/" />
    )
  }
/>


        {/* Ruta para Llegadas 
        <Route
          path="/manual"
          element={
            isAuthenticated ?
             (
              <AuthenticatedLayout>
                <ServicioManual />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        /> */}

        {/* Ruta para la Bitácora 
        <Route
          path="/bitacora"
          element={
            isAuthenticated ?
             (
              <AuthenticatedLayout>
                <BitacoraPage />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        /> */}

        {/* Ruta para Gestión 
        <Route
          path="/gestion"
          element={
            isAuthenticated ?
             (
              <AuthenticatedLayout>
                <GestionPage />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        /> */}

        {/* Ruta por defecto o no encontrada */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;
